import { TabCountLabel } from "lib/@components/tabs/tab-count-label"
import { getSharingLink } from "routes/sharing/controller/get-sharing-link"
import { getShareLinkFieldResponseForViewer } from "./share-link-fields.controller"
import { countOutstandingRequiredFields } from "./requested-information-count"

// Recipient "Requested Information" tab label: shows the number of required fields the viewer still
// needs to fill in. The count drops to zero (and the pill disappears) once every required field has a
// value; it refreshes as the viewer's saved response is invalidated.
export function RequestedInformationTabLabel({ shareLinkId, regimeId }) {
    const shareLink = getSharingLink.useResults(shareLinkId)
    const response = getShareLinkFieldResponseForViewer.useResults({ shareLinkId, regimeId })
    const count = countOutstandingRequiredFields(shareLink?.requestedFields, response?.values)

    return (
        <TabCountLabel label="Requested Information" count={count} data-cy="requested-information-outstanding-count" />
    )
}
